import { render, staticRenderFns } from "./Qualification - 副本.vue?vue&type=template&id=15c29ff0&scoped=true"
import script from "./Qualification - 副本.vue?vue&type=script&lang=js"
export * from "./Qualification - 副本.vue?vue&type=script&lang=js"
import style0 from "./Qualification - 副本.vue?vue&type=style&index=0&id=15c29ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c29ff0",
  null
  
)

export default component.exports